export default __webpack_public_path__ + "static/media/nirjala-ekadashi.119a79b2.jpg";